/**
 * paywall_style 埋点字段：付费墙样式枚举与解析。
 * 只按可见 bottom.length 映射，不再读 split 开关或是否有轮播：
 * - coins_only_two_column  可见 bottom <= 4（含 0）
 * - original_three_column  可见 bottom > 4
 * split_carousel_card 仅保留类型兼容，本期不再产出。
 */
export type TPaywallStyle = 'original_three_column' | 'coins_only_two_column' | 'split_carousel_card';

/**
 * 根据可见底部网格档位数解析付费墙样式。
 * @param visibleBottomCount 过滤无匹配卡后的 slots.bottom 数量
 */
export function resolvePaywallStyle(visibleBottomCount: number): TPaywallStyle {
    if (visibleBottomCount > 4) {
        return 'original_three_column';
    }
    return 'coins_only_two_column';
}
